module.exports = __webpack_public_path__ + "static/cube5-c207cc027ac4be1060b3e7d67b130ff7.svg";